import CasinoTV from "../../components/CasinoTV.jsx";
import React, { useEffect } from "react";
import {
  getOddsByRunner,
  getUniversalCasinoPlExposureByRunner,
  GetUniversalLastTenResult,
} from "./genericFunctions";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,
  uniCasinoBetAPI,
} from "../../service/casino";
import { useParams } from "react-router-dom";
import { CARD_ARRAY } from "../casino/CasinoGeneric";
import PlaceBetUniversal from "./PlaceBetUniversal";
import toast from "react-hot-toast";
import GenericCasinoTimer from "../../components/GenericCasinoTimer";

export default function AndarBahar() {
  const { id: GAME_ID } = useParams();
  const haveModule2 = GAME_ID?.includes("LUCKY_7_A");
  const haveCardSuit = GAME_ID?.includes("LUCKY_7_A");
  const [selected, setSelected] = React.useState("DRAGON");
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const andarCardRef = React.useRef();
  const baharCardRef = React.useRef();
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [odds?.roundId]);
  const placeBet = async (
    runnerName,

    isBack = true
  ) => {
    let odd = getOddsByRunner(odds, runnerName, true);
    let payload = { ...placeBetPayload };
    payload.marketIdWithSelectionId = `${odd?.marketId}_${odd?.selectionId}`;

    payload.runnerName = runnerName;
    payload[isBack ? "back" : "lay"] = odd[isBack ? "back1" : "lay1"];
    payload.marketId = odds?.roundId;
    payload.amount = 100;
    payload.type = isBack ? "back" : "lay";
    payload.casinoGames = GAME_ID;

    setPlaceBetPayload(payload);
  };
  const placeBetCallApi = async () => {
    setLoading(true);
    const { response, code, status } = await uniCasinoBetAPI(placeBetPayload);
    if (code === 200) {
      toast.success(status);
      getOdds();
      setPlaceBetPayload(null);
    } else {
      setPlaceBetPayload(null);
      toast.error(response);
    }
    setLoading(false);
  };
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);

  // Add auto-scroll effect when new cards are added
  React.useEffect(() => {
    if (andarCardRef.current) {
      andarCardRef.current.scrollLeft = andarCardRef.current.scrollWidth;
    }
    if (baharCardRef.current) {
      baharCardRef.current.scrollLeft = baharCardRef.current.scrollWidth;
    }
  }, [odds?.playerCards, odds?.extraCards]);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);

  // Function to check time condition
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt
      ? new Date(odds.roundWinnerUpdatedAt).getTime()
      : 0;

    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    // Add interval for time condition check
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);
  return (
    <app-andar-bahar-casino
      _nghost-ng-c180702173=""
      className="ng-star-inserted"
    >
      <app-video-player _ngcontent-ng-c180702173="" _nghost-ng-c595356512="">
        <div
          style={{ overflowY: "scroll" }}
          _ngcontent-ng-c595356512=""
          className="videoPlayer"
        >
          <CasinoTV casinoGames={GAME_ID} />

          <div
            _ngcontent-ng-c595356512=""
            className="andar-bahir-container ng-star-inserted"
          >
            <div _ngcontent-ng-c595356512="" className="video-overlay">
              <div
                _ngcontent-ng-c595356512=""
                className="round-id mb-1 text-white"
              >
                RID: {odds?.roundId}
              </div>
              {/* {odds?.playerCards
                ?.sort(
                  (a, b) =>
                    a?.forPerson?.charCodeAt(0) - b?.forPerson?.charCodeAt(0)
                )
                .map((player) => (
                  <div _ngcontent-ng-c595356512="">
                    <h3 _ngcontent-ng-c595356512="" className="text-white">
                      {player?.forPerson?.slice(0, 1).toUpperCase()}
                    </h3>
                    <div _ngcontent-ng-c595356512="">
                      {player?.cards?.map((card) => (
                        <img
                          _ngcontent-ng-c595356512=""
                          src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                        />
                      ))}
                    </div>
                  </div>
                ))} */}
              <div
                _ngcontent-ng-c595356512=""
                className="row align-items-center h-83"
              >
                <div _ngcontent-ng-c595356512="" className="col-1">
                  <div _ngcontent-ng-c595356512="" className="row">
                    <div _ngcontent-ng-c595356512="" className="col-12">
                      <p
                        _ngcontent-ng-c595356512=""
                        className="mb-0 text-white"
                      >
                        <b _ngcontent-ng-c595356512="" className="text-a">
                          A
                        </b>
                      </p>
                    </div>
                  </div>
                  <div _ngcontent-ng-c595356512="" className="row">
                    <div _ngcontent-ng-c595356512="" className="col-12">
                      <p
                        _ngcontent-ng-c595356512=""
                        className="mb-0 text-white"
                      >
                        <b _ngcontent-ng-c595356512="" className="text-b">
                          B
                        </b>
                      </p>
                    </div>
                  </div>
                </div>
                <div _ngcontent-ng-c595356512="" className="col-2 ps-1">
                  <img
                    _ngcontent-ng-c595356512=""
                    className="card-right"
                    style={{ width: "23px !important" }}
                    src={`https://casino.queenexch.com/assets/cards/${
                      odds?.extraCards?.find(
                        (player) => player?.forPerson == "RESULT"
                      )?.cards[0]?.cardValue
                    }.png`}
                  />
                </div>
                <div _ngcontent-ng-c595356512="" className="col-7 custom-css-x">
                  <div _ngcontent-ng-c595356512="" className="row">
                    <div _ngcontent-ng-c595356512="" className="col-12">
                      <div _ngcontent-ng-c595356512="" className="crousel">
                        <owl-carousel-o
                          _ngcontent-ng-c595356512=""
                          _nghost-ng-c3098439908=""
                        >
                          <div
                            _ngcontent-ng-c3098439908=""
                            className="owl-carousel owl-theme owl-rtl owl-loaded owl-responsive owl-drag"
                          >
                            <div
                              _ngcontent-ng-c3098439908=""
                              className="owl-stage-outer ng-star-inserted"
                            >
                              <owl-stage
                                _ngcontent-ng-c3098439908=""
                                className="ng-tns-c556756694-4 ng-star-inserted"
                              >
                                <div className="ng-tns-c556756694-4">
                                  <div
                                    className="owl-stage ng-tns-c556756694-4"
                                    style={{
                                      width: 82,
                                      overflowX: "scroll",
                                      transform: "translate3d(0px, 0px, 0px)",
                                      transition: "all",
                                    }}
                                    ref={andarCardRef}
                                  >
                                    {odds?.extraCards
                                      ?.filter(
                                        (player) => player?.forPerson == "ANDAR"
                                      )
                                      ?.splice(1, 1)

                                      ?.map((player) =>
                                        player?.cards?.map((card) => (
                                          <div
                                            className="owl-item ng-tns-c556756694-4 ng-trigger ng-trigger-autoHeight active ng-star-inserted"
                                            style={{ width: 39, marginLeft: 2 }}
                                          >
                                            <img
                                              _ngcontent-ng-c595356512=""
                                              className="img img-responsive andrimg ng-star-inserted"
                                              style={{
                                                width: "23px !important",
                                              }}
                                              src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                                            />
                                          </div>
                                        ))
                                      )}

                                    {odds?.playerCards

                                      ?.filter(
                                        (player) =>
                                          player?.forPerson == "ANDAR_CARDS"
                                      )
                                      ?.map((player) =>
                                        player?.cards?.map((card, index) => (
                                          <div
                                            className="owl-item ng-tns-c556756694-4 ng-trigger ng-trigger-autoHeight active ng-star-inserted"
                                            style={{
                                              width: 39,
                                              marginLeft: 2,
                                            }}
                                          >
                                            <img
                                              _ngcontent-ng-c595356512=""
                                              className="img img-responsive andrimg ng-star-inserted"
                                              style={{
                                                width: "23px !important",
                                              }}
                                              src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                                            />
                                          </div>
                                        ))
                                      )}
                                  </div>
                                </div>
                              </owl-stage>
                            </div>

                            <div
                              _ngcontent-ng-c3098439908=""
                              className="owl-nav  ng-star-inserted"
                            >
                              <div
                                onClick={() => {
                                  andarCardRef.current.scrollLeft += 50;
                                }}
                                _ngcontent-ng-c3098439908=""
                                className="owl-prev "
                              >
                                &lt;
                              </div>
                              <div
                                onClick={() => {
                                  andarCardRef.current.scrollLeft -= 50;
                                }}
                                _ngcontent-ng-c3098439908=""
                                className="owl-next "
                              >
                                &gt;
                              </div>
                            </div>
                            <div
                              _ngcontent-ng-c3098439908=""
                              className="owl-dots disabled ng-star-inserted"
                            ></div>
                          </div>
                        </owl-carousel-o>
                      </div>
                      <div _ngcontent-ng-c595356512="" className="crousel mt-2">
                        <owl-carousel-o
                          _ngcontent-ng-c595356512=""
                          _nghost-ng-c3098439908=""
                        >
                          <div
                            _ngcontent-ng-c3098439908=""
                            className="owl-carousel owl-theme owl-rtl owl-loaded owl-responsive owl-drag"
                          >
                            <div
                              _ngcontent-ng-c3098439908=""
                              className="owl-stage-outer ng-star-inserted"
                            >
                              <owl-stage
                                _ngcontent-ng-c3098439908=""
                                className="ng-tns-c556756694-5 ng-star-inserted"
                              >
                                <div className="ng-tns-c556756694-5">
                                  <div
                                    ref={baharCardRef}
                                    className="owl-stage ng-tns-c556756694-5"
                                    style={{
                                      width: 82,
                                      overflowX: "scroll",
                                      transform: "translate3d(0px, 0px, 0px)",
                                      transition: "all",
                                    }}
                                  >
                                    {odds?.extraCards
                                      ?.filter(
                                        (player) => player?.forPerson == "BAHAR"
                                      )
                                      ?.splice(1, 1)
                                      ?.map((player) =>
                                        player?.cards?.map((card) => (
                                          <div
                                            className="owl-item ng-tns-c556756694-4 ng-trigger ng-trigger-autoHeight active ng-star-inserted"
                                            style={{
                                              width: 39,
                                              marginLeft: 2,
                                            }}
                                          >
                                            <img
                                              _ngcontent-ng-c595356512=""
                                              className="img img-responsive andrimg ng-star-inserted"
                                              style={{
                                                width: "23px !important",
                                              }}
                                              src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                                            />
                                          </div>
                                        ))
                                      )}
                                    {odds?.playerCards
                                      ?.filter(
                                        (player) =>
                                          player?.forPerson == "BAHAR_CARDS"
                                      )
                                      ?.map((player) =>
                                        player?.cards?.map((card, index) => (
                                          <div
                                            className="owl-item ng-tns-c556756694-4 ng-trigger ng-trigger-autoHeight active ng-star-inserted"
                                            style={{
                                              width: 39,
                                              marginLeft: 2,
                                            }}
                                          >
                                            <img
                                              _ngcontent-ng-c595356512=""
                                              className="img img-responsive andrimg ng-star-inserted"
                                              style={{
                                                width: "23px !important",
                                              }}
                                              src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                                            />
                                          </div>
                                        ))
                                      )}
                                  </div>
                                </div>
                              </owl-stage>
                            </div>

                            <div
                              _ngcontent-ng-c3098439908=""
                              className="owl-nav  ng-star-inserted"
                            >
                              <div
                                onClick={() => {
                                  baharCardRef.current.scrollLeft += 50;
                                }}
                                _ngcontent-ng-c3098439908=""
                                className="owl-prev "
                              >
                                &lt;
                              </div>
                              <div
                                onClick={() => {
                                  baharCardRef.current.scrollLeft -= 50;
                                }}
                                _ngcontent-ng-c3098439908=""
                                className="owl-next "
                              >
                                &gt;
                              </div>
                            </div>
                            <div
                              _ngcontent-ng-c3098439908=""
                              className="owl-dots disabled ng-star-inserted"
                            ></div>
                          </div>
                        </owl-carousel-o>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {showWinnerOverlay && (
            <div _ngcontent-ng-c595356512="" className="winnerOverlay">
              <div
                _ngcontent-ng-c595356512=""
                className="mini-result-new active"
              >
                <span _ngcontent-ng-c595356512="">
                  {" "}
                  {odds?.roundWinner} win{" "}
                </span>
                {/**/}
              </div>
              <span
                _ngcontent-ng-c595356512=""
                style={{ position: "absolute" }}
              >
                <canvas
                  _ngcontent-ng-c595356512=""
                  width="100vw"
                  height="100vh"
                />
              </span>
              {/**/}
            </div>
          )}

          <div _ngcontent-ng-c595356512="" className="timer-overlay">
            <GenericCasinoTimer time={odds?.seconds} status={odds?.status} />
          </div>
        </div>

        <div
          _ngcontent-ng-c595356512=""
          id="rulesModal"
          tabIndex={-1}
          aria-labelledby="exampleModalLabelaexampleModalLabela"
          aria-hidden="true"
          className="modal fade"
        >
          <div _ngcontent-ng-c595356512="" className="modal-dialog rules-wrap">
            <div
              _ngcontent-ng-c595356512=""
              role="document"
              id="rulesList___BV_modal_content_"
              tabIndex={-1}
              className="modal-content rules-content"
            >
              <header
                _ngcontent-ng-c595356512=""
                id="rulesList___BV_modal_header_"
                className="rules-wrap"
              >
                <a _ngcontent-ng-c595356512="">
                  <h3
                    _ngcontent-ng-c595356512=""
                    id="rulesList___BV_modal_title_"
                    data-bs-toggle="modal"
                    data-bs-target="#rulesModal"
                    className="modal-title"
                  >
                    Rules
                  </h3>
                </a>
                <button
                  _ngcontent-ng-c595356512=""
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  className="close"
                >
                  ×
                </button>
              </header>
              <div
                _ngcontent-ng-c595356512=""
                id="rulesList___BV_modal_body_"
                className="modal-body"
              >
                <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
              </div>
              <div _ngcontent-ng-c595356512="">
                <ul _ngcontent-ng-c595356512="" className="btn-wrap break">
                  <li _ngcontent-ng-c595356512="">
                    <a
                      _ngcontent-ng-c595356512=""
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      className="btnok"
                    >
                      OK
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </app-video-player>
      <div
        _ngcontent-ng-c180702173=""
        id="marketScroll"
        className="overflow-auto"
        style={{ height: 576 }}
      >
        <div
          _ngcontent-ng-c180702173=""
          className="ab-2-container tether-target tether-element-attached-top tether-element-attached-center tether-target-attached-top tether-target-attached-center ng-star-inserted"
        >
          {["A", "B"]?.map((currentRow) => (
            <>
              <div _ngcontent-ng-c180702173="" className="bet-a">
                <div _ngcontent-ng-c180702173="" className="a-title">
                  {currentRow}
                </div>
                <div _ngcontent-ng-c180702173="" className="sa 1782383">
                  <div
                    onClick={() => placeBet(`SIDE BET ${currentRow}`)}
                    _ngcontent-ng-c180702173=""
                    className={`price ${
                      getOddsByRunner(odds, `SIDE BET ${currentRow}`, true)
                        ?.status == "SUSPEND" && "suspendedandar"
                    }`}
                  >
                    <div _ngcontent-ng-c180702173="">
                      {" "}
                      SIDE BET {currentRow}{" "}
                    </div>
                    <div _ngcontent-ng-c180702173="" className="mt-1">
                      {getOddsByRunner(odds, `SIDE BET ${currentRow}`)}
                    </div>
                  </div>
                  <div _ngcontent-ng-c180702173="" className="book">
                    <span _ngcontent-ng-c180702173="" className="extra-pf">
                      <div _ngcontent-ng-c180702173="" className="profitLoss">
                        <span
                          _ngcontent-ng-c180702173=""
                          className="zeroPL ng-star-inserted"
                        >
                          {getUniversalCasinoPlExposureByRunner(
                            exposure,
                            `SIDE BET ${currentRow}`
                          )}
                        </span>
                      </div>
                    </span>
                  </div>
                </div>
                <div _ngcontent-ng-c180702173="" className="first-bet 1782381">
                  <div
                    onClick={() => placeBet(`1st BET ${currentRow}`)}
                    _ngcontent-ng-c180702173=""
                    className={`price ${
                      getOddsByRunner(odds, `1st BET ${currentRow}`, true)
                        ?.status == "SUSPEND" && "suspendedandar"
                    }`}
                  >
                    <div _ngcontent-ng-c180702173="">
                      {" "}
                      1st BET {currentRow}{" "}
                    </div>
                    <div _ngcontent-ng-c180702173="" className="mt-1">
                      {getOddsByRunner(odds, `1st BET ${currentRow}`)}
                    </div>
                  </div>
                  <div _ngcontent-ng-c180702173="" className="book">
                    <span _ngcontent-ng-c180702173="" className="extra-pf">
                      <div _ngcontent-ng-c180702173="" className="profitLoss">
                        <span
                          _ngcontent-ng-c180702173=""
                          className="zeroPL ng-star-inserted"
                        >
                          {getUniversalCasinoPlExposureByRunner(
                            exposure,
                            `1st BET ${currentRow}`
                          )}
                        </span>
                      </div>
                    </span>
                  </div>
                </div>
                <div _ngcontent-ng-c180702173="" className="second-bet 1782385">
                  <div
                    onClick={() => placeBet(`2st BET ${currentRow}`)}
                    _ngcontent-ng-c180702173=""
                    className={`price ${
                      getOddsByRunner(odds, `2st BET ${currentRow}`, true)
                        ?.status == "SUSPEND" && "suspendedandar"
                    }`}
                  >
                    <div _ngcontent-ng-c180702173="">
                      {" "}
                      2st BET {currentRow}{" "}
                    </div>
                    <div _ngcontent-ng-c180702173="" className="mt-1">
                      {getOddsByRunner(odds, `2st BET ${currentRow}`)}
                    </div>
                  </div>
                  <div _ngcontent-ng-c180702173="" className="book">
                    <span _ngcontent-ng-c180702173="" className="extra-pf">
                      <div _ngcontent-ng-c180702173="" className="profitLoss">
                        <span
                          _ngcontent-ng-c180702173=""
                          className="zeroPL ng-star-inserted"
                        >
                          {getUniversalCasinoPlExposureByRunner(
                            exposure,
                            `2st BET ${currentRow}`
                          )}
                        </span>
                      </div>
                    </span>
                  </div>
                </div>
                <div _ngcontent-ng-c180702173="" className="a-title">
                  {currentRow}
                </div>
              </div>
              {["SIDE BET", "1st BET", "2st BET"]?.map(
                (currentRow2) =>
                  placeBetPayload?.marketIdWithSelectionId?.split("_")[1] ==
                    `${
                      getOddsByRunner(
                        odds,
                        `${currentRow2} ${currentRow}`,
                        true
                      )?.selectionId
                    }` && (
                    <PlaceBetUniversal
                      placeBetPayload={placeBetPayload}
                      setPlaceBetPayload={setPlaceBetPayload}
                      placeBet={placeBetCallApi}
                    />
                  )
              )}
            </>
          ))}
        </div>

        <div
          _ngcontent-ng-c180702173=""
          className="mt-2 ab-2-containerodd ng-star-inserted"
        >
          <div
            _ngcontent-ng-c180702173=""
            className="col-6 ab-2-box leftbox tether-target tether-element-attached-bottom tether-abutted tether-abutted-top tether-target-attached-top tether-element-attached-right tether-target-attached-right"
          >
            <div _ngcontent-ng-c180702173="" className="row">
              <div
                _ngcontent-ng-c180702173=""
                className="col-6 text-center 995566"
              >
                <div _ngcontent-ng-c180702173="" className="bltitle">
                  <b _ngcontent-ng-c180702173=""> ODD </b>
                </div>
                <div
                  onClick={() => placeBet("ODD")}
                  _ngcontent-ng-c180702173=""
                  className={`back mt-1 blbox price ${
                    (getOddsByRunner(odds, `ODD`, true)?.status == "SUSPEND" ||
                      odds?.status == "SUSPEND") &&
                    "suspendedandar"
                  }`}
                >
                  <span _ngcontent-ng-c180702173="" className="odd">
                    {getOddsByRunner(odds, "ODD")}
                  </span>
                </div>
                <div _ngcontent-ng-c180702173="" className="mt-1">
                  <span _ngcontent-ng-c180702173="" className="extra-pf">
                    <div _ngcontent-ng-c180702173="" className="profitLoss">
                      <span
                        _ngcontent-ng-c180702173=""
                        className="zeroPL ng-star-inserted"
                      >
                        {getUniversalCasinoPlExposureByRunner(exposure, `ODD`)}
                      </span>
                    </div>
                  </span>
                </div>
              </div>
              <div
                _ngcontent-ng-c180702173=""
                className="col-6 text-center 665566"
              >
                <div _ngcontent-ng-c180702173="" className="bltitle">
                  <b _ngcontent-ng-c180702173=""> EVEN </b>
                </div>
                <div
                  onClick={() => placeBet("EVEN")}
                  _ngcontent-ng-c180702173=""
                  className={`back mt-1 blbox price ${
                    (getOddsByRunner(odds, `EVEN`, true)?.status == "SUSPEND" ||
                      odds?.status == "SUSPEND") &&
                    "suspendedandar"
                  }`}
                >
                  <span _ngcontent-ng-c180702173="" className="odd">
                    {getOddsByRunner(odds, "EVEN")}
                  </span>
                </div>
                <div _ngcontent-ng-c180702173="" className="mt-1">
                  <span _ngcontent-ng-c180702173="" className="extra-pf">
                    <div _ngcontent-ng-c180702173="" className="profitLoss">
                      <span
                        _ngcontent-ng-c180702173=""
                        className="zeroPL ng-star-inserted"
                      >
                        {getUniversalCasinoPlExposureByRunner(exposure, `EVEN`)}
                      </span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
          {["ODD", "EVEN"]?.map(
            (currentRow) =>
              placeBetPayload?.marketIdWithSelectionId?.split("_")[1] ==
                `${getOddsByRunner(odds, currentRow, true)?.selectionId}` && (
                <PlaceBetUniversal
                  placeBetPayload={placeBetPayload}
                  setPlaceBetPayload={setPlaceBetPayload}
                  placeBet={placeBetCallApi}
                />
              )
          )}

          <div
            _ngcontent-ng-c180702173=""
            className="mobile-screen col-6 ab-2-box rightbox tether-target tether-element-attached-top tether-element-attached-center tether-target-attached-top tether-target-attached-center"
          >
            <div _ngcontent-ng-c180702173="" className="row">
              <div
                _ngcontent-ng-c180702173=""
                className="col-3 text-center 58259772337 ng-star-inserted"
              >
                <div _ngcontent-ng-c180702173="" className="bltitle">
                  <img
                    _ngcontent-ng-c180702173=""
                    src="https://casino.queenexch.com/assets/andarBahar/SPADES.png"
                  />
                </div>
                <div
                  onClick={() => placeBet("SPADES")}
                  _ngcontent-ng-c180702173=""
                  className={`back mt-1 blbox price ${
                    getOddsByRunner(odds, `SPADES`, true)?.status ==
                      "SUSPEND" && "suspendedandar"
                  }`}
                >
                  <span _ngcontent-ng-c180702173="" className="odd">
                    {getOddsByRunner(odds, "SPADES")}
                  </span>
                </div>
                <div _ngcontent-ng-c180702173="" className="mt-1">
                  <span _ngcontent-ng-c180702173="" className="extra-pf">
                    <span _ngcontent-ng-c180702173="" className="profitLoss">
                      <span
                        _ngcontent-ng-c180702173=""
                        className="zeroPL ng-star-inserted"
                      >
                        {getUniversalCasinoPlExposureByRunner(
                          exposure,
                          `SPADES`
                        )}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <div
                onClick={() => placeBet("HEARTS")}
                _ngcontent-ng-c180702173=""
                className="col-3 text-center 58259772337 ng-star-inserted"
              >
                <div _ngcontent-ng-c180702173="" className="bltitle">
                  <img
                    _ngcontent-ng-c180702173=""
                    src="https://casino.queenexch.com/assets/andarBahar/HEARTS.png"
                  />
                </div>
                <div
                  _ngcontent-ng-c180702173=""
                  className={`back mt-1 blbox price ${
                    getOddsByRunner(odds, `HEARTS`, true)?.status ==
                      "SUSPEND" && "suspendedandar"
                  }`}
                >
                  <span _ngcontent-ng-c180702173="" className="odd">
                    {getOddsByRunner(odds, "HEARTS")}
                  </span>
                </div>
                <div _ngcontent-ng-c180702173="" className="mt-1">
                  <span _ngcontent-ng-c180702173="" className="extra-pf">
                    <span _ngcontent-ng-c180702173="" className="profitLoss">
                      <span
                        _ngcontent-ng-c180702173=""
                        className="zeroPL ng-star-inserted"
                      >
                        {getUniversalCasinoPlExposureByRunner(
                          exposure,
                          `HEARTS`
                        )}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <div
                onClick={() => placeBet("DIAMONDS")}
                _ngcontent-ng-c180702173=""
                className="col-3 text-center 58259772337 ng-star-inserted"
              >
                <div _ngcontent-ng-c180702173="" className="bltitle">
                  <img
                    _ngcontent-ng-c180702173=""
                    src="https://casino.queenexch.com/assets/andarBahar/DIAMONDS.png"
                  />
                </div>
                <div
                  _ngcontent-ng-c180702173=""
                  className={`back mt-1 blbox price ${
                    getOddsByRunner(odds, `DIAMONDS`, true)?.status ==
                      "SUSPEND" && "suspendedandar"
                  }`}
                >
                  <span _ngcontent-ng-c180702173="" className="odd">
                    {getOddsByRunner(odds, "DIAMONDS")}
                  </span>
                </div>
                <div _ngcontent-ng-c180702173="" className="mt-1">
                  <span _ngcontent-ng-c180702173="" className="extra-pf">
                    <span _ngcontent-ng-c180702173="" className="profitLoss">
                      <span
                        _ngcontent-ng-c180702173=""
                        className="zeroPL ng-star-inserted"
                      >
                        {getUniversalCasinoPlExposureByRunner(
                          exposure,
                          `DIAMONDS`
                        )}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <div
                onClick={() => placeBet("CLUBS")}
                _ngcontent-ng-c180702173=""
                className="col-3 text-center 58259772337 ng-star-inserted"
              >
                <div _ngcontent-ng-c180702173="" className="bltitle">
                  <img
                    _ngcontent-ng-c180702173=""
                    src="https://casino.queenexch.com/assets/andarBahar/CLUBS.png"
                  />
                </div>
                <div
                  _ngcontent-ng-c180702173=""
                  className={`back mt-1 blbox price ${
                    getOddsByRunner(odds, `CLUBS`, true)?.status == "SUSPEND" &&
                    "suspendedandar"
                  }`}
                >
                  <span _ngcontent-ng-c180702173="" className="odd">
                    {getOddsByRunner(odds, "CLUBS")}
                  </span>
                </div>
                <div _ngcontent-ng-c180702173="" className="mt-1">
                  <span _ngcontent-ng-c180702173="" className="extra-pf">
                    <span _ngcontent-ng-c180702173="" className="profitLoss">
                      <span
                        _ngcontent-ng-c180702173=""
                        className="zeroPL ng-star-inserted"
                      >
                        {getUniversalCasinoPlExposureByRunner(
                          exposure,
                          `CLUBS`
                        )}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          {["SPADES", "HEARTS", "DIAMONDS", "CLUBS"]?.map(
            (currentRow) =>
              placeBetPayload?.marketIdWithSelectionId?.split("_")[1] ==
                `${getOddsByRunner(odds, currentRow, true)?.selectionId}` && (
                <PlaceBetUniversal
                  placeBetPayload={placeBetPayload}
                  setPlaceBetPayload={setPlaceBetPayload}
                  placeBet={placeBetCallApi}
                />
              )
          )}
        </div>

        <div
          _ngcontent-ng-c180702173=""
          className="ab-2-box mt-2 tether-element-attached-top tether-element-attached-center tether-target-attached-top tether-target-attached-center ng-star-inserted"
        >
          <div _ngcontent-ng-c180702173="" className="col-md-12 text-center">
            <span _ngcontent-ng-c180702173="" className="text12">
              12
            </span>
          </div>
          <div _ngcontent-ng-c180702173="" className="col-md-12 text-center">
            {CARD_ARRAY?.map((item) => (
              <div
                onClick={() => placeBet(item)}
                _ngcontent-ng-c180702173=""
                className="m-r-5 card-image price 5825901 ng-star-inserted"
              >
                <div
                  _ngcontent-ng-c180702173=""
                  className={odds?.status == "SUSPEND" && "suspended"}
                >
                  <img
                    _ngcontent-ng-c180702173=""
                    src={`https://casino.queenexch.com/assets/lucky7_cards/${item}.png`}
                  />
                </div>
                <div
                  _ngcontent-ng-c180702173=""
                  className="ubook text-center mb-2"
                >
                  <span _ngcontent-ng-c180702173="" className="extra-pf">
                    <div
                      _ngcontent-ng-c180702173=""
                      className="ubook text-center text-success h-18"
                      style={{ width: 34 }}
                    >
                      <span
                        _ngcontent-ng-c180702173=""
                        className="zeroPL ng-star-inserted"
                        style={{ color: "black" }}
                      >
                        {getUniversalCasinoPlExposureByRunner(exposure, item)}
                      </span>
                    </div>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        {CARD_ARRAY?.map(
          (currentRow) =>
            placeBetPayload?.marketIdWithSelectionId?.split("_")[1] ==
              `${getOddsByRunner(odds, currentRow, true)?.selectionId}` && (
              <PlaceBetUniversal
                placeBetPayload={placeBetPayload}
                setPlaceBetPayload={setPlaceBetPayload}
                placeBet={placeBetCallApi}
              />
            )
        )}

        <GetUniversalLastTenResult lastResult={lastResult} />
      </div>
    </app-andar-bahar-casino>
  );
}
